var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.30733 5.22434C9.0082 4.92522 8.52322 4.92522 8.2241 5.22434C7.92497 5.52347 7.92497 6.00845 8.2241 6.30757L13.8101 11.8936L10.2667 15.4371C9.96753 15.7362 9.96753 16.2212 10.2667 16.5203C10.5658 16.8195 11.0508 16.8195 11.3499 16.5203L15.435 12.4352C15.7341 12.1361 15.7341 11.6511 15.435 11.352L9.30733 5.22434ZM8.74976 18.7553C9.16397 18.7553 9.49976 18.4195 9.49976 18.0053C9.49976 17.5911 9.16397 17.2553 8.74976 17.2553C8.33554 17.2553 7.99976 17.5911 7.99976 18.0053C7.99976 18.4195 8.33554 18.7553 8.74976 18.7553Z",
    fill: "#191818",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron);
export default __webpack_public_path__ + "static/media/chevron.cc5369694fb3029199f043ec58faa0ab.svg";
export { ForwardRef as ReactComponent };